import {Divider} from 'primereact/divider';
import logo from '../assets/e-metal_logo.png';
import * as Icon from '../assets/icons';
import {useAppSelector, useTranslation} from '../hooks';

import useMediaQuery from '../hooks/media';
import {themeState} from '../redux/slices/app';
import {
  ADDRESS,
  BUSINESS_PHONE,
  Colors,
  COMPANY_NAME,
  EMAIL,
  formatPhoneNumber,
  GOOGLE_MAP,
  MOBILE_PHONE,
} from '../utils';
import './footer.css';
import SocialLinks from './SocialLinks';

const Footer = () => {
  const {t} = useTranslation();
  const {isXSmall} = useMediaQuery();
  const selectedTheme = useAppSelector(themeState);

  return (
    <footer className="footer surface-ground" id="iletişim">
      {selectedTheme === 'dark' && <Divider />}
      <div className="footer__links">
        <a
          className="footer__link"
          href={GOOGLE_MAP}
          aria-label="Company Address"
          target="_blank"
          rel="noopener noreferrer">
          <div className="footer__links__info">
            <div className="footer__links__icon">
              <Icon.Map
                size={isXSmall ? 30 : 40}
                color={
                  selectedTheme === 'dark' ? Colors.white : Colors.primary700
                }
              />
            </div>
            <p className="footer__links__text">{ADDRESS}</p>
          </div>
        </a>

        <a
          className="footer__link"
          href={`https://wa.me/9${MOBILE_PHONE}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp Numarası">
          <div className="footer__links__info">
            <div className="footer__links__icon">
              <Icon.Whatsapp
                size={isXSmall ? 30 : 40}
                color={
                  selectedTheme === 'dark' ? Colors.white : Colors.primary700
                }
              />
            </div>
            <p className="footer__links__text">
              {formatPhoneNumber(MOBILE_PHONE)}
            </p>
          </div>
        </a>

        <a
          className="footer__link"
          target="_blank"
          rel="noopener noreferrer"
          href={`tel:${BUSINESS_PHONE}`}
          aria-label="Telefon Numarası">
          <div className="footer__links__info">
            <div className="footer__links__icon">
              <Icon.Call
                size={isXSmall ? 30 : 40}
                color={
                  selectedTheme === 'dark' ? Colors.white : Colors.primary700
                }
              />
            </div>
            <p className="footer__links__text">
              {formatPhoneNumber(BUSINESS_PHONE)}
            </p>
          </div>
        </a>

        <a
          className="footer__link"
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:${EMAIL}`}
          aria-label="Info Email Address">
          <div className="footer__links__info">
            <div className="footer__links__icon">
              <Icon.Email2
                size={isXSmall ? 30 : 40}
                color={
                  selectedTheme === 'dark' ? Colors.white : Colors.primary700
                }
              />
            </div>
            <p className="footer__links__text">{EMAIL}</p>
          </div>
        </a>
      </div>

      <div className="footer__social">
        <SocialLinks />
      </div>

      <div className="footer__header">
        <img
          className="footer__logo"
          src={logo}
          alt="e-metal_logo"
          title={COMPANY_NAME}
        />
      </div>

      <p className="footer__copyright text-xs">
        &copy; {new Date().getFullYear()}, {COMPANY_NAME} {t('copyRightText')}
      </p>
    </footer>
  );
};

export default Footer;
